import { executeCalculation } from "./_calculation.js";
import { syncInputValues } from "./_input.js";
import { setupInputListeners } from "./_input-listeners.js";
import { getAllElements, getInputElements, createContexts } from "./_dom.js";

/**
 * タブ切り替えの初期化
 */
export const initTabs = () => {
    const elements = getAllElements();

    if (
        !elements.tabContainer ||
        !elements.titleButtonsContainer ||
        !elements.titleButtons.length ||
        !elements.contentSections.length
    )
        return null;

    // コンテキストオブジェクトを作成
    const contexts = createContexts(elements.resultElement);

    // 既存のボタンにイベントリスナーを追加
    elements.titleButtons.forEach((button, index) => {
        button.addEventListener("click", () => {
            // 現在のタブタイプを取得
            const currentActiveSection = document.querySelector(
                ".js-ai-assessment__content-item[data-active]"
            );
            const currentType = currentActiveSection
                ? currentActiveSection.dataset.type
                : null;

            // ボタンのdata-active属性を更新
            elements.titleButtons.forEach((btn) => delete btn.dataset.active);
            button.dataset.active = "";

            // セクションの表示を切り替え
            elements.contentSections.forEach((section, i) => {
                if (i === index) {
                    section.dataset.active = "";
                } else {
                    delete section.dataset.active;
                }
            });

            // 物件種別を更新
            const newType = button.dataset.type;
            if (elements.pgHead) {
                elements.pgHead.dataset.type = newType;
                if (elements.hiddenInput) {
                    elements.hiddenInput.value = newType;
                }
            }

            // 郵便番号と土地面積の値を同期
            if (currentType && currentType !== newType) {
                const fromInputs = getInputElements(currentType);
                const toInputs = getInputElements(newType);
                syncInputValues(
                    fromInputs.zipcode,
                    fromInputs.landArea,
                    toInputs.zipcode,
                    toInputs.landArea
                );
                // コンテキストを更新
                contexts[newType].inputs = toInputs;
            }

            // 入力値がある場合は計算を実行
            setTimeout(() => {
                executeCalculation(newType, contexts[newType]);
            }, 100);
        });
    });

    // 入力フィールドの監視を設定（両方のタブに設定）
    setupInputListeners("house", contexts.house);
    setupInputListeners("land", contexts.land);
};
